import { render, staticRenderFns } from "./eventMobile.vue?vue&type=template&id=33f618e8&scoped=true&"
import script from "./eventMobile.vue?vue&type=script&lang=js&"
export * from "./eventMobile.vue?vue&type=script&lang=js&"
import style0 from "./eventMobile.vue?vue&type=style&index=0&id=33f618e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f618e8",
  null
  
)

export default component.exports